import React from 'react';
import { Section } from './ui/Section';
import { useLanguage } from '../context/LanguageContext';
export function AuthorityTimeBlock() {
  const {
    t
  } = useLanguage();
  return <Section background="charcoal" className="text-center" data-id="element-11">
      <div className="max-w-3xl mx-auto space-y-10" data-id="element-12">
        <div className="space-y-6 text-2xl md:text-4xl font-serif text-white leading-tight" data-id="element-13">
          <p data-id="element-14">{t.authorityTimeBlock.line1}</p>
          <p className="text-luxury-gray" data-id="element-15">{t.authorityTimeBlock.line2}</p>
          <p className="text-luxury-gold italic" data-id="element-16">
            {t.authorityTimeBlock.line3}
          </p>
        </div>
      </div>
    </Section>;
}